import { isGoogleAnalyticsConfigured } from './is-google-analytics-configured.utils'
import {
  registerGoogleAnalyticsProvider,
  type GoogleAnalyticsRegistrationConfig,
  type GtagFn,
} from './register-google-analytics-provider.utils'
import type { GoogleAnalyticsLogger } from '../providers/google-analytics.provider'

interface UseGtagResult {
  gtag?: GtagFn
}

/** Registers GA from the client plugin; skips when ID missing, warns on failure. */
export function registerGoogleAnalyticsFromPlugin(
  analyticsConfig: GoogleAnalyticsRegistrationConfig,
  resolveGtag: () => UseGtagResult,
  logger?: GoogleAnalyticsLogger
): void {
  const measurementId = analyticsConfig.providers?.googleAnalytics?.measurementId

  if (!isGoogleAnalyticsConfigured(measurementId)) {
    return
  }

  try {
    const { gtag } = resolveGtag()
    registerGoogleAnalyticsProvider(analyticsConfig, gtag, logger)
  } catch (error) {
    logger?.warn('[Analytics] Google Analytics registration failed', { error })
  }
}
